(function () {
  var META_PATH = '/products/haro-clear-meta';
  var STANDARD_PATH = '/products/haro-clear';
  var LOCK_KEY = 'haro_meta_flow_lock_until_v1';
  var LOCK_COOKIE = 'haro_meta_flow_lock_until';
  var LOCK_DAYS = 14;

  function nowMs() {
    return Date.now();
  }

  function toNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function writeCookie(name, value, days) {
    try {
      var expires = new Date(nowMs() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(String(value)) + '; expires=' + expires + '; path=/; SameSite=Lax';
    } catch (error) {}
  }

  function readLockUntil() {
    var fromStorage = 0;
    var fromCookie = 0;
    try {
      fromStorage = toNumber(window.localStorage.getItem(LOCK_KEY));
    } catch (error) {}
    fromCookie = toNumber(readCookie(LOCK_COOKIE));
    return Math.max(fromStorage, fromCookie);
  }

  function clearLock() {
    try {
      window.localStorage.removeItem(LOCK_KEY);
    } catch (error) {}
    writeCookie(LOCK_COOKIE, '', -1);
  }

  function setLock() {
    var until = nowMs() + LOCK_DAYS * 24 * 60 * 60 * 1000;
    try {
      window.localStorage.setItem(LOCK_KEY, String(until));
    } catch (error) {}
    writeCookie(LOCK_COOKIE, until, LOCK_DAYS);
    return until;
  }

  function isMetaPath(pathname) {
    return pathname === META_PATH || pathname === META_PATH + '/';
  }

  function isStandardPath(pathname) {
    return pathname === STANDARD_PATH || pathname === STANDARD_PATH + '/';
  }

  function isLockedMetaVisitor() {
    var until = readLockUntil();
    if (!until) return false;
    var maxAllowedUntil = nowMs() + LOCK_DAYS * 24 * 60 * 60 * 1000;
    if (until > maxAllowedUntil) {
      until = setLock();
    }
    if (until <= nowMs()) {
      clearLock();
      return false;
    }
    return true;
  }

  function toMetaHref(sourceHref) {
    try {
      var url = new URL(sourceHref, window.location.origin);
      if (!isStandardPath(url.pathname)) return null;
      url.pathname = META_PATH;
      return url.toString();
    } catch (error) {
      return null;
    }
  }

  function rewriteStandardLinks(root) {
    if (!root) return;
    var links = root.querySelectorAll ? root.querySelectorAll('a[href]') : [];
    links.forEach(function (a) {
      var rewritten = toMetaHref(a.getAttribute('href'));
      if (rewritten) a.setAttribute('href', rewritten);
    });
  }

  function run() {
    var currentPath = window.location.pathname || '';

    if (isMetaPath(currentPath)) {
      setLock();
    }

    if (!isLockedMetaVisitor()) return;

    if (isStandardPath(currentPath)) {
      var target = new URL(window.location.href);
      target.pathname = META_PATH;
      window.location.replace(target.toString());
      return;
    }

    rewriteStandardLinks(document);

    document.addEventListener('click', function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!anchor) return;
      var rewritten = toMetaHref(anchor.getAttribute('href'));
      if (rewritten) {
        anchor.setAttribute('href', rewritten);
      }
    }, true);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node && node.nodeType === 1) rewriteStandardLinks(node);
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  run();
})();
